import type { InventoryResource } from '@repo/api-gw-sdk';

import ConfirmationDialog from '@/components/dialogs/confirmationDialog';
import { useDAL } from '@/contexts/useDAL';

export function RestartAutomaticDataClassClassification({
  open,
  onClose,
  entities,
}: {
  open: boolean;
  onClose: () => void;
  entities: InventoryResource[];
}) {
  const dal = useDAL();

  const onSave = () => {
    void Promise.all(
      entities.map((entity) =>
        dal.inventory.dataClasses.deleteOverride(entity.id).then(() => {
          entity.classifications = entity.classifications || {};
          entity.classifications.dataClassesDetails =
            entity.classifications.dataClassesDetails || {};
          entity.classifications.dataClassesDetails.isOverridden = false;
        })
      )
    ).finally(onClose);
  };

  return (
    <ConfirmationDialog
      isOpen={open}
      title='Resume auto-classification for data classes'
      description='Data classes will be automatically detected, and your overridden data classes will be removed. This could change the applied backup policies and controls.'
      onCancel={onClose}
      onConfirm={onSave}
      buttonTitle='Resume'
      buttonIconClass='material-symbols-motion-play-outline-rounded'
      confirmSnackbarText='Data class auto-classification resumed.'
    />
  );
}
